// Minimal constants needed for price parts functionality
// Extracted from apps/web/src/components/product/const.ts

const unitNames = {
  Inches: 'Inches',
  Feet: 'Feet',
  Millimeters: 'Millimeters',
  Meters: 'Meters',
  SQ_Inches: 'SQ_Inches',
  SQ_Feet: 'SQ_Feet',
  SQ_Millimeters: 'SQ_Millimeters',
  SQ_Meters: 'SQ_Meters',
  CU_Inches: 'CU_Inches',
  CU_Feet: 'CU_Feet',
  CU_Millimeters: 'CU_Millimeters',
  CU_Meters: 'CU_Meters',
  Each: 'Each',
  Month: 'Month',
  Day: 'Day',
  Hour: 'Hour',
  LBS: 'LBS',
  Kilos: 'Kilos',
  Yards: 'Yards',
  SQ_Yards: 'SQ_Yards',
  CU_Yards: 'CU_Yards',
};

export const units = [
  { id: unitNames.Yards, name: 'Yard', abbr: 'yd' },
  { id: unitNames.Feet, name: 'Feet', abbr: 'ft' },
  { id: unitNames.Inches, name: 'Inch', abbr: 'in' },
  { id: unitNames.Meters, name: 'Meter', abbr: 'm' },
  { id: unitNames.Millimeters, name: 'Millimeter', abbr: 'mm' },
  { id: unitNames.SQ_Yards, name: 'Square Yard', abbr: 'sq yd' },
  { id: unitNames.SQ_Feet, name: 'Square Feet', abbr: 'sq ft' },
  { id: unitNames.SQ_Inches, name: 'Square Inch', abbr: 'sq in' },
  { id: unitNames.SQ_Meters, name: 'Square Meter', abbr: 'm²' },
  { id: unitNames.SQ_Millimeters, name: 'Square Millimeter', abbr: 'mm²' },
  { id: unitNames.CU_Yards, name: 'Cubic Yard', abbr: 'cu yd' },
  { id: unitNames.CU_Feet, name: 'Cubic Feet', abbr: 'cu ft' },
  { id: unitNames.CU_Inches, name: 'Cubic Inch', abbr: 'cu in' },
  { id: unitNames.CU_Meters, name: 'Cubic Meter', abbr: 'm³' },
  { id: unitNames.CU_Millimeters, name: 'Cubic Millimeter', abbr: 'mm³' },
  { id: unitNames.LBS, name: 'Pound', abbr: 'lb' },
  { id: unitNames.Kilos, name: 'Kilogram', abbr: 'kg' },
  { id: unitNames.Each, name: 'Each', abbr: 'Each' },
  { id: unitNames.Month, name: 'Month', abbr: 'Month' },
  { id: unitNames.Day, name: 'Day', abbr: 'Day' },
  { id: unitNames.Hour, name: 'Hour', abbr: 'Hour' },
];

export const pricingMethod = {
  INPUT_PRICE: 'Input Price',
  CALCULATED_PRICE: 'Calculated Price (Cost & Margin)',
};

// Export as default object to match original usage pattern
const ProdConst = {
  units,
};

export default ProdConst;
